import type { GenerationImpactScenarioSnapshot, GenerationMaxPowerStudySnapshot } from '../../types/generationImpact';
import type { SiteEvidenceDocument } from '../../types/siteEvidence';
import { declaredWaterConsumptionProvenance } from './declaredWaterConsumptionProvenance';
import { matchWholeSiteWaterRoles, wholeSiteWaterLedger } from '../water/waterQuantityRoles';

/** Withhold the whole solved envelope: removing a ceiling after solving cannot
 * recover a valid maximum. Retain the stored study for audit and recompute only
 * after the scenario's consumption limit has a correct role. */
export function maxPowerWaterAuthorityReason(
  scenario: Pick<GenerationImpactScenarioSnapshot, 'input'>,
  study: GenerationMaxPowerStudySnapshot | null | undefined,
  sed?: SiteEvidenceDocument | null,
): string | null {
  if (!study) return null;
  for (const ceiling of study.ceilings) {
    if (ceiling.id !== 'water-consumption' || ceiling.limitUnit !== 'gal/day' || ceiling.limitValue == null) continue;
    const provenance = declaredWaterConsumptionProvenance(scenario.input, ceiling.limitValue);
    if (provenance === 'documented-consumptive-limit') continue;
    if (provenance === 'document-unbound' || matchWholeSiteWaterRoles(wholeSiteWaterLedger(sed), ceiling.limitValue).length) {
      return 'Max-power study withheld: its water ceiling is not supported as a consumptive-use limit. Correct the water input role and rerun the max-power study before using its capacity.';
    }
  }
  return null;
}
